export enum FormMetaState {
  open = '',
  loading = 'loading',
  offline = 'offline',
  online = 'online',
  retry = 'retry',
  fail = 'fail',
  submitting = 'submitting',
  success = 'success',
}